/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { pickControllerCreate } from '../fn/pick/pick-controller-create';
import { PickControllerCreate$Params } from '../fn/pick/pick-controller-create';
import { pickControllerDelete } from '../fn/pick/pick-controller-delete';
import { PickControllerDelete$Params } from '../fn/pick/pick-controller-delete';
import { pickControllerFindAll } from '../fn/pick/pick-controller-find-all';
import { PickControllerFindAll$Params } from '../fn/pick/pick-controller-find-all';
import { pickControllerFindAllActive } from '../fn/pick/pick-controller-find-all-active';
import { PickControllerFindAllActive$Params } from '../fn/pick/pick-controller-find-all-active';
import { pickControllerFindById } from '../fn/pick/pick-controller-find-by-id';
import { PickControllerFindById$Params } from '../fn/pick/pick-controller-find-by-id';
import { pickControllerFindByUserId } from '../fn/pick/pick-controller-find-by-user-id';
import { PickControllerFindByUserId$Params } from '../fn/pick/pick-controller-find-by-user-id';
import { pickControllerFindPopularPlaces } from '../fn/pick/pick-controller-find-popular-places';
import { PickControllerFindPopularPlaces$Params } from '../fn/pick/pick-controller-find-popular-places';
import { pickControllerGetHotPicks } from '../fn/pick/pick-controller-get-hot-picks';
import { PickControllerGetHotPicks$Params } from '../fn/pick/pick-controller-get-hot-picks';
import { pickControllerLiked } from '../fn/pick/pick-controller-liked';
import { PickControllerLiked$Params } from '../fn/pick/pick-controller-liked';
import { pickControllerReport } from '../fn/pick/pick-controller-report';
import { PickControllerReport$Params } from '../fn/pick/pick-controller-report';
import { pickControllerSearch } from '../fn/pick/pick-controller-search';
import { PickControllerSearch$Params } from '../fn/pick/pick-controller-search';
import { pickControllerSearchCursor } from '../fn/pick/pick-controller-search-cursor';
import { PickControllerSearchCursor$Params } from '../fn/pick/pick-controller-search-cursor';
import { pickControllerSearchOffset } from '../fn/pick/pick-controller-search-offset';
import { PickControllerSearchOffset$Params } from '../fn/pick/pick-controller-search-offset';
import { pickControllerToggleBlocked } from '../fn/pick/pick-controller-toggle-blocked';
import { PickControllerToggleBlocked$Params } from '../fn/pick/pick-controller-toggle-blocked';
import { pickControllerToggleLike } from '../fn/pick/pick-controller-toggle-like';
import { PickControllerToggleLike$Params } from '../fn/pick/pick-controller-toggle-like';
import { pickControllerTogglePicked } from '../fn/pick/pick-controller-toggle-picked';
import { PickControllerTogglePicked$Params } from '../fn/pick/pick-controller-toggle-picked';
import { pickControllerUpdate } from '../fn/pick/pick-controller-update';
import { PickControllerUpdate$Params } from '../fn/pick/pick-controller-update';
import { PickDto } from '../models/pick-dto';
import { PickSearchResponseDto } from '../models/pick-search-response-dto';

@Injectable({ providedIn: 'root' })
export class PickService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pickControllerSearch()` */
  static readonly PickControllerSearchPath = '/api/picks/search';

  /**
   * 픽 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerSearch$Response(params: PickControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PickSearchResponseDto>> {
    return pickControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerSearch(params: PickControllerSearch$Params, context?: HttpContext): Observable<PickSearchResponseDto> {
    return this.pickControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickSearchResponseDto>): PickSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `pickControllerSearchOffset()` */
  static readonly PickControllerSearchOffsetPath = '/api/picks/{id}/search/offset';

  /**
   * 픽 id로 오프셋 기반 조회.
   *
   * id로 픽을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerSearchOffset$Response(params: PickControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return pickControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 id로 오프셋 기반 조회.
   *
   * id로 픽을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerSearchOffset(params: PickControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.pickControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `pickControllerSearchCursor()` */
  static readonly PickControllerSearchCursorPath = '/api/picks/search/cursor';

  /**
   * 픽 커서 기반 조회.
   *
   * 픽을 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerSearchCursor$Response(params: PickControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return pickControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 커서 기반 조회.
   *
   * 픽을 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerSearchCursor(params: PickControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.pickControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `pickControllerFindPopularPlaces()` */
  static readonly PickControllerFindPopularPlacesPath = '/api/picks/popular-places';

  /**
   * 실시간 인기 픽 조회.
   *
   * 가장 많이 조회된 픽을 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerFindPopularPlaces()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindPopularPlaces$Response(params?: PickControllerFindPopularPlaces$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
    return pickControllerFindPopularPlaces(this.http, this.rootUrl, params, context);
  }

  /**
   * 실시간 인기 픽 조회.
   *
   * 가장 많이 조회된 픽을 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerFindPopularPlaces$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindPopularPlaces(params?: PickControllerFindPopularPlaces$Params, context?: HttpContext): Observable<Array<PickDto>> {
    return this.pickControllerFindPopularPlaces$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PickDto>>): Array<PickDto> => r.body)
    );
  }

  /** Path part for operation `pickControllerLiked()` */
  static readonly PickControllerLikedPath = '/api/picks/liked';

  /**
   * 좋아요한 게시글 조회.
   *
   * 회원이 좋아요한 게시글을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerLiked()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerLiked$Response(params?: PickControllerLiked$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
    return pickControllerLiked(this.http, this.rootUrl, params, context);
  }

  /**
   * 좋아요한 게시글 조회.
   *
   * 회원이 좋아요한 게시글을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerLiked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerLiked(params?: PickControllerLiked$Params, context?: HttpContext): Observable<Array<PickDto>> {
    return this.pickControllerLiked$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PickDto>>): Array<PickDto> => r.body)
    );
  }

  /** Path part for operation `pickControllerGetHotPicks()` */
  static readonly PickControllerGetHotPicksPath = '/api/picks/hot-picks';

  /**
   * 이번 주 가장 핫한 픽 조회.
   *
   * 좋아요 수를 기준으로 이번 주 가장 핫한 픽 7개를 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerGetHotPicks()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerGetHotPicks$Response(params?: PickControllerGetHotPicks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
    return pickControllerGetHotPicks(this.http, this.rootUrl, params, context);
  }

  /**
   * 이번 주 가장 핫한 픽 조회.
   *
   * 좋아요 수를 기준으로 이번 주 가장 핫한 픽 7개를 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerGetHotPicks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerGetHotPicks(params?: PickControllerGetHotPicks$Params, context?: HttpContext): Observable<Array<PickDto>> {
    return this.pickControllerGetHotPicks$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PickDto>>): Array<PickDto> => r.body)
    );
  }

  /** Path part for operation `pickControllerFindAllActive()` */
  static readonly PickControllerFindAllActivePath = '/api/picks/active';

  /**
   * 활성화된 픽 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerFindAllActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindAllActive$Response(params?: PickControllerFindAllActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
    return pickControllerFindAllActive(this.http, this.rootUrl, params, context);
  }

  /**
   * 활성화된 픽 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerFindAllActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindAllActive(params?: PickControllerFindAllActive$Params, context?: HttpContext): Observable<Array<PickDto>> {
    return this.pickControllerFindAllActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PickDto>>): Array<PickDto> => r.body)
    );
  }

  /** Path part for operation `pickControllerFindAll()` */
  static readonly PickControllerFindAllPath = '/api/picks';

  /**
   * 모든 픽 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindAll$Response(params?: PickControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
    return pickControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 픽 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindAll(params?: PickControllerFindAll$Params, context?: HttpContext): Observable<Array<PickDto>> {
    return this.pickControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PickDto>>): Array<PickDto> => r.body)
    );
  }

  /** Path part for operation `pickControllerCreate()` */
  static readonly PickControllerCreatePath = '/api/picks';

  /**
   * 새 픽 등록.
   *
   * 새로운 픽을 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pickControllerCreate$Response(params: PickControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 새 픽 등록.
   *
   * 새로운 픽을 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pickControllerCreate(params: PickControllerCreate$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerFindById()` */
  static readonly PickControllerFindByIdPath = '/api/picks/{id}';

  /**
   * 픽 조회.
   *
   * 입력한 ID와 일치하는 픽을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindById$Response(params: PickControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 조회.
   *
   * 입력한 ID와 일치하는 픽을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindById(params: PickControllerFindById$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerDelete()` */
  static readonly PickControllerDeletePath = '/api/picks/{id}';

  /**
   * 픽 삭제.
   *
   * 픽를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerDelete$Response(params: PickControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 삭제.
   *
   * 픽를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerDelete(params: PickControllerDelete$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerUpdate()` */
  static readonly PickControllerUpdatePath = '/api/picks/{id}';

  /**
   * 픽 수정.
   *
   * 픽 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pickControllerUpdate$Response(params: PickControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 수정.
   *
   * 픽 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pickControllerUpdate(params: PickControllerUpdate$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerFindByUserId()` */
  static readonly PickControllerFindByUserIdPath = '/api/picks/user/{userId}';

  /**
   * 사용자 픽 조회.
   *
   * 특정 사용자의 픽 중 특정 픽을 제외한 목록을 반환합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerFindByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindByUserId$Response(params: PickControllerFindByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PickDto>>> {
    return pickControllerFindByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * 사용자 픽 조회.
   *
   * 특정 사용자의 픽 중 특정 픽을 제외한 목록을 반환합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerFindByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerFindByUserId(params: PickControllerFindByUserId$Params, context?: HttpContext): Observable<Array<PickDto>> {
    return this.pickControllerFindByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PickDto>>): Array<PickDto> => r.body)
    );
  }

  /** Path part for operation `pickControllerReport()` */
  static readonly PickControllerReportPath = '/api/picks/{id}/report';

  /**
   * 픽 게시글 신고.
   *
   * 픽 게시글을 신고합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pickControllerReport$Response(params: PickControllerReport$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerReport(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 게시글 신고.
   *
   * 픽 게시글을 신고합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pickControllerReport(params: PickControllerReport$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerTogglePicked()` */
  static readonly PickControllerTogglePickedPath = '/api/picks/{id}/toggle-picked';

  /**
   * MD 픽 여부.
   *
   * 픽 카드에서 MD PICK 뱃지를 토글합니다. MD PICK 뱃지가 활성화되면 픽 카드에 MD PICK 뱃지가 표시됩니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerTogglePicked()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerTogglePicked$Response(params: PickControllerTogglePicked$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerTogglePicked(this.http, this.rootUrl, params, context);
  }

  /**
   * MD 픽 여부.
   *
   * 픽 카드에서 MD PICK 뱃지를 토글합니다. MD PICK 뱃지가 활성화되면 픽 카드에 MD PICK 뱃지가 표시됩니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerTogglePicked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerTogglePicked(params: PickControllerTogglePicked$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerTogglePicked$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerToggleBlocked()` */
  static readonly PickControllerToggleBlockedPath = '/api/picks/{id}/toggle-blocked';

  /**
   * 픽 숨김/노출.
   *
   * 픽 게시글의 숨김/노출 상태를 컨트롤 합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerToggleBlocked()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerToggleBlocked$Response(params: PickControllerToggleBlocked$Params, context?: HttpContext): Observable<StrictHttpResponse<PickDto>> {
    return pickControllerToggleBlocked(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 숨김/노출.
   *
   * 픽 게시글의 숨김/노출 상태를 컨트롤 합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerToggleBlocked$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerToggleBlocked(params: PickControllerToggleBlocked$Params, context?: HttpContext): Observable<PickDto> {
    return this.pickControllerToggleBlocked$Response(params, context).pipe(
      map((r: StrictHttpResponse<PickDto>): PickDto => r.body)
    );
  }

  /** Path part for operation `pickControllerToggleLike()` */
  static readonly PickControllerToggleLikePath = '/api/picks/{id}/toggle-like';

  /**
   * 픽 좋아요 여부.
   *
   * 픽 좋아요 여부를 확인합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pickControllerToggleLike()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerToggleLike$Response(params: PickControllerToggleLike$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return pickControllerToggleLike(this.http, this.rootUrl, params, context);
  }

  /**
   * 픽 좋아요 여부.
   *
   * 픽 좋아요 여부를 확인합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pickControllerToggleLike$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pickControllerToggleLike(params: PickControllerToggleLike$Params, context?: HttpContext): Observable<boolean> {
    return this.pickControllerToggleLike$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
